module.exports = __webpack_public_path__ + "static/media/Needlepoint_Logo_FinalImage.79d20be3.png";